<div
  class="dropdown"
  [ngClass]="{'expanded': expanded, 'disabled': disabled}"
  (clickOutside)="onInputBlur()"
>
  <form
    class="dropdown__search"
    *ngIf="showSearchField"
    (submit)="applySearch($event)"
  >
    <input
      type="text"
      [(ngModel)]="pagination.search"
      [ngModelOptions]="{standalone: true}"
      [disabled]="disabled"
      [attr.placeholder]="placeholder"
      (focus)="onInputFocus()"
      (ngModelChange)="searchSubject.next($event)"
    >
    <button>
      <mat-icon>search</mat-icon>
    </button>
  </form>

  <div
    class="dropdown__list"
    [ngClass]="{'dropdown__list--expanded': expanded}"
  >
    <div
      class="dropdown__item"
      *ngFor="let item of list"
      (click)="selectItem(item)"
      [ngClass]="{'selected': isItemSelected(item)}"
    >
      {{item[this.propertyToShow]}}
    </div>

    <div class="dropdown__item disabled" *ngIf="list && !list.length">
      Not found
    </div>

    <div class="dropdown__item more" *ngIf="!pagination.isLast" (click)="onLoadMore()">
      Load More
    </div>
  </div>
</div>
